import { Notification } from "@/components/admin/notification"
import { TextInput } from "@/components/admin/text-input"
import { Avatar, AvatarImage } from "@/components/ui/avatar"
import { Button } from "@/components/ui/button"
import { supabaseClient } from "@/lib/utils/client.supabase.conf"
import { Form, required, useNotify } from "ra-core"
import { useState } from "react"
import type { FieldValues, SubmitHandler } from "react-hook-form"

export const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const notify = useNotify()

  const handleSubmit: SubmitHandler<FieldValues> = async values => {
    setLoading(true)
    try {
      const { error } = await supabaseClient.auth.resetPasswordForEmail(
        values.email,
        {
          redirectTo: `${window.location.origin}/reset-password`,
        }
      )

      if (error) {
        throw error
      }

      setEmailSent(true)
      notify("Un e-mail de réinitialisation a été envoyé à votre adresse", {
        type: "success",
      })
    } catch (error: any) {
      notify(
        error?.message ||
          "Une erreur s'est produite lors de l'envoi de l'e-mail",
        {
          type: "error",
        }
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex">
      <div className="container relative grid flex-col items-center justify-center sm:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
          <div
            className="absolute inset-0 bg-zinc-900"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1471604571702-62f6c507f68c?q=80&w=2748&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="relative z-20 mt-auto">
            <blockquote className="space-y-2">
              <p className="text-lg"></p>
              <footer className="text-sm text-white">{`Förnya ©  ${new Date().getFullYear()}`}</footer>
            </blockquote>
          </div>
        </div>
        <div className="lg:p-8">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[40vw] xs:w-[80vw]">
            <div className="flex flex-col space-y-2 text-center items-center my-18 ">
              <Avatar className="w-40 h-40">
                <AvatarImage src="https://galvtfsffmozysmfvnnw.supabase.co/storage/v1/object/public/images/system/logo600x600.png" />
              </Avatar>
              <h1 className="text-2xl font-semibold tracking-tight">
                Mot de passe oublié
              </h1>
              <p className="text-sm text-muted-foreground">
                {emailSent
                  ? "Vérifiez votre boîte de réception"
                  : "Entrez votre adresse e-mail pour réinitialiser votre mot de passe"}
              </p>
            </div>
            {!emailSent ? (
              <Form className="space-y-4" onSubmit={handleSubmit}>
                <TextInput
                  label="E-mail"
                  source="email"
                  type="email"
                  validate={required()}
                />
                <Button
                  type="submit"
                  className="cursor-pointer w-full my-12"
                  disabled={loading}
                >
                  {loading
                    ? "Envoi en cours..."
                    : "Envoyer le lien de réinitialisation"}
                </Button>
                <div className="text-center">
                  <a
                    href="/login"
                    className="text-sm underline-offset-4 hover:underline"
                  >
                    Retour à la connexion
                  </a>
                </div>
              </Form>
            ) : (
              <div className="space-y-4">
                <p className="text-sm text-center">
                  Un e-mail contenant un lien de réinitialisation a été envoyé à
                  votre adresse. Veuillez vérifier votre boîte de réception et
                  suivre les instructions.
                </p>
                <Button
                  onClick={() => setEmailSent(false)}
                  variant="outline"
                  className="w-full"
                >
                  Renvoyer l'e-mail
                </Button>
                <div className="text-center">
                  <a
                    href="/login"
                    className="text-sm underline-offset-4 hover:underline"
                  >
                    Retour à la connexion
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Notification />
    </div>
  )
}
